module.exports = __webpack_public_path__ + "static/media/picwall.4d75557f.png";